import { render } from "./PlanFlat.vue?vue&type=template&id=bdc96562&scoped=true"
import script from "./PlanFlat.vue?vue&type=script&lang=js"
export * from "./PlanFlat.vue?vue&type=script&lang=js"

import "./PlanFlat.vue?vue&type=style&index=0&id=bdc96562&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdc96562"]])

export default __exports__